(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 95318:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 20862:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(50008)["default"]);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 50008:
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 55517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1591);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },

    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },

    /* Styles applied to the root element if `variant="inset"`. */
    inset: {
      marginLeft: 72
    },

    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.divider, 0.08)
    },

    /* Styles applied to the root element if `variant="middle"`. */
    middle: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      height: '100%',
      width: 1
    },

    /* Styles applied to the root element if `flexItem={true}`. */
    flexItem: {
      alignSelf: 'stretch',
      height: 'auto'
    }
  };
};
var Divider = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Divider(props, ref) {
  var _props$absolute = props.absolute,
      absolute = _props$absolute === void 0 ? false : _props$absolute,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'hr' : _props$component,
      _props$flexItem = props.flexItem,
      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
      _props$light = props.light,
      light = _props$light === void 0 ? false : _props$light,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$role = props.role,
      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
    role: role,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiDivider'
})(Divider));

/***/ }),

/***/ 44343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "capitalize": function() { return /* reexport */ capitalize/* default */.Z; },
  "createChainedFunction": function() { return /* reexport */ createChainedFunction/* default */.Z; },
  "createSvgIcon": function() { return /* reexport */ createSvgIcon/* default */.Z; },
  "debounce": function() { return /* reexport */ debounce/* default */.Z; },
  "deprecatedPropType": function() { return /* reexport */ deprecatedPropType; },
  "isMuiElement": function() { return /* reexport */ isMuiElement/* default */.Z; },
  "ownerDocument": function() { return /* reexport */ ownerDocument/* default */.Z; },
  "ownerWindow": function() { return /* reexport */ ownerWindow/* default */.Z; },
  "requirePropFactory": function() { return /* reexport */ requirePropFactory; },
  "setRef": function() { return /* reexport */ setRef/* default */.Z; },
  "unstable_useId": function() { return /* reexport */ unstable_useId/* default */.Z; },
  "unsupportedProp": function() { return /* reexport */ unsupportedProp; },
  "useControlled": function() { return /* reexport */ useControlled/* default */.Z; },
  "useEventCallback": function() { return /* reexport */ useEventCallback/* default */.Z; },
  "useForkRef": function() { return /* reexport */ useForkRef/* default */.Z; },
  "useIsFocusVisible": function() { return /* reexport */ useIsFocusVisible/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(82568);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js + 1 modules
var createSvgIcon = __webpack_require__(594);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/debounce.js
var debounce = __webpack_require__(79437);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/deprecatedPropType.js
function deprecatedPropType(validator, reason) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(83711);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(30626);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(80713);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/requirePropFactory.js
function requirePropFactory(componentNameInError) {
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/setRef.js
var setRef = __webpack_require__(34236);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/unsupportedProp.js
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(22775);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unstable_useId.js
var unstable_useId = __webpack_require__(95001);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(24896);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/index.js













 // eslint-disable-next-line camelcase




/***/ }),

/***/ 63957:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(95318);

var _interopRequireWildcard = __webpack_require__(20862);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');

exports.Z = _default;

/***/ }),

/***/ 10064:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(95318);

var _interopRequireWildcard = __webpack_require__(20862);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 13H5v-2h14v2z"
}), 'Remove');

exports.Z = _default;

/***/ }),

/***/ 22128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(594);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
}), 'Share'));

/***/ }),

/***/ 2108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
}));

var _utils = __webpack_require__(44343);

/***/ }),

/***/ 45301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(88494);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./components/common/SEO.tsx
var SEO = __webpack_require__(11647);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js + 1 modules
var createSvgIcon = __webpack_require__(594);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/InfoRounded.js


/* harmony default export */ var InfoRounded = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1-8h-2V7h2v2z"
}), 'InfoRounded'));
// EXTERNAL MODULE: ./components/hero/Hero.module.scss
var Hero_module = __webpack_require__(6235);
var Hero_module_default = /*#__PURE__*/__webpack_require__.n(Hero_module);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/WatchLater.js


/* harmony default export */ var WatchLater = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"
}), 'WatchLater'));
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Restaurant.js
var Restaurant = __webpack_require__(30347);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/LocalShipping.js


/* harmony default export */ var LocalShipping = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
}), 'LocalShipping'));
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Euro.js
var Euro = __webpack_require__(6594);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/Phone.js


/* harmony default export */ var Phone = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
}), 'Phone'));
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/LocationOn.js
var LocationOn = __webpack_require__(20275);
// EXTERNAL MODULE: ./components/common/index.ts + 28 modules
var common = __webpack_require__(26075);
// EXTERNAL MODULE: ./utils/helpers.ts + 37 modules
var helpers = __webpack_require__(22412);
;// CONCATENATED MODULE: ./components/hero/info/InfoDialog.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var InfoDialog = function(param) {
    var info = param.info, open = param.open, onClose = param.onClose;
    var _Math;
    var ref = (0,react.useState)(false), scheduleExpanded = ref[0], setScheduleExpanded = ref[1];
    var toggleExpanded = function() {
        return setScheduleExpanded(!scheduleExpanded);
    };
    var label = info.address.label, schedule = info.schedule;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* CustomDialog */.QA, {
        maxWidth: "sm",
        position: "absolute",
        color: "transparent",
        backIconColor: "white",
        open: open,
        onClose: onClose,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* GoogleMaps */.hz, {
                query: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "m0 bold",
                        children: info.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "m0 textSecondary",
                        children: info.cusine.join(" \u2022 ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "pre-line f16",
                        children: info.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* SPListItem */.yK, {
                title: info.openStatus.open ? "Deschis pana la ".concat(schedule[new Date().getDay()].until) : info.openStatus.next,
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(WatchLater, {}),
                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* ExpandButton */.Vh, {
                    isExpanded: scheduleExpanded,
                    toggle: toggleExpanded,
                    border: false
                }),
                onClick: toggleExpanded
            }),
            scheduleExpanded && (0,helpers/* sortedSchedule */.xT)(schedule).map(function(item, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(info_OpenTimeItem, {
                    schedule: item,
                    expanded: scheduleExpanded
                }, idx);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* SPListItem */.yK, {
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Restaurant/* default */.Z, {}),
                title: info.cusine.join(", ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* SPListItem */.yK, {
                title: "Livrare de la ".concat((0,helpers/* formatPrice */.T4)((_Math = Math).min.apply(_Math, _toConsumableArray(info.delivery.zones.map(function(z) {
                    return z.delivery_fee;
                }))))),
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalShipping, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* SPListItem */.yK, {
                title: "Plata: ".concat(info.payment_methods.join(", ").replace("card_on_delivery", "card la livrare")),
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Euro/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "tel:".concat(info.phoneNumber),
                "aria-label": "tel",
                style: {
                    borderBottom: "1px solid #000"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* SPListItem */.yK, {
                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone, {}),
                    title: info.phoneNumber,
                    divider: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                href: "https://maps.google.com/?q=".concat(info.address.label),
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* SPListItem */.yK, {
                    title: info.address.mainText,
                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn/* default */.Z, {})
                })
            })
        ]
    });
};
/* harmony default export */ var info_InfoDialog = (InfoDialog);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
;// CONCATENATED MODULE: ./components/hero/info/OpenTimeItem.tsx




var OpenTimeItem = function(param) {
    var schedule = param.schedule, expanded = param.expanded;
    var today = new Date().getDay();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                dense: true,
                disableGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                    className: expanded && schedule.day === today ? "between bold" : "between ",
                    style: {
                        marginLeft: 72,
                        marginRight: 16
                    },
                    primary: (0,helpers/* dayIndexToRomanian */.go)(schedule.day),
                    secondary: !schedule.from ? "Inchis" : "".concat(schedule.from, " - ").concat(schedule.until)
                })
            }),
            expanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                style: {
                    marginLeft: 70
                }
            })
        ]
    });
};
/* harmony default export */ var info_OpenTimeItem = (OpenTimeItem);

;// CONCATENATED MODULE: ./components/hero/index.ts





// EXTERNAL MODULE: ./context/index.ts + 10 modules
var context = __webpack_require__(64648);
// EXTERNAL MODULE: ./hooks/index.ts + 17 modules
var hooks = __webpack_require__(44978);
// EXTERNAL MODULE: ./utils/config.ts
var config = __webpack_require__(50639);
;// CONCATENATED MODULE: ./utils/HeroHelper.ts
function HeroHelper_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function HeroHelper_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return HeroHelper_arrayLikeToArray(arr);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function HeroHelper_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function HeroHelper_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function HeroHelper_toConsumableArray(arr) {
    return HeroHelper_arrayWithoutHoles(arr) || HeroHelper_iterableToArray(arr) || HeroHelper_unsupportedIterableToArray(arr) || HeroHelper_nonIterableSpread();
}
function HeroHelper_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return HeroHelper_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return HeroHelper_arrayLikeToArray(o, minLen);
}

var EXTRA_TIME = 5;
// const formattedTimeRange = (time: number) => `${time} - ${time + EXTRA_TIME} min`
var HeroHelper = /*#__PURE__*/ function() {
    "use strict";
    function HeroHelper(info, userState, deliveryType) {
        var _this = this;
        _classCallCheck(this, HeroHelper);
        this.loading = function() {
            return _this.userState.loading && _this.info !== null;
        };
        this.info = info;
        this.userState = userState;
        this.deliveryType = deliveryType;
    }
    var _proto = HeroHelper.prototype;
    _proto.deliveryTime = function deliveryTime() {
        var _userState = this.userState, loading = _userState.loading, delivery = _userState.delivery;
        if (loading) return " ";
        var restaurantDeliveryTime = this.info.delivery.time;
        var userTime = Math.round(delivery.distanceMatrix.duration.value / 60);
        var roundedUserTime = Math.round(userTime / 5) * 5;
        if (this.deliveryType === "delivery") {
            return "".concat(restaurantDeliveryTime + roundedUserTime + EXTRA_TIME * 3, " min");
        } else {
            return "".concat(restaurantDeliveryTime, " min");
        }
    };
    _proto.minOrder = function minOrder() {
        var _Math;
        var _userState = this.userState, delivery = _userState.delivery, loading = _userState.loading, user = _userState.user;
        if (this.deliveryType === "pickup" || loading) return " ";
        var lowestDeliveryFee = (_Math = Math).min.apply(_Math, HeroHelper_toConsumableArray(this.info.delivery.zones.map(function(z) {
            return z.min_order;
        })));
        return (0,helpers/* formatPrice */.T4)(user ? delivery.zone.min_order : lowestDeliveryFee);
    };
    _proto.freeDelivery = function freeDelivery() {
        var _Math;
        var _userState = this.userState, delivery = _userState.delivery, loading = _userState.loading, user = _userState.user;
        if (loading || this.deliveryType === "pickup") return "";
        var lowestFreeDeliverySum = (_Math = Math).min.apply(_Math, HeroHelper_toConsumableArray(this.info.delivery.zones.map(function(z) {
            return z.free_delivery_treshold;
        })));
        return ">" + (0,helpers/* formatPrice */.T4)(user ? delivery.zone.free_delivery_treshold : lowestFreeDeliverySum);
    };
    _proto.deliveryFee = function deliveryFee() {
        var _userState = this.userState, loading = _userState.loading, addressError = _userState.addressError, user = _userState.user, delivery = _userState.delivery;
        if (loading) return 0;
        if (addressError || !user) {
            var _Math;
            var ref, ref1, ref2;
            var lowestFee = (_Math = Math).min.apply(_Math, HeroHelper_toConsumableArray((ref = this.info) === null || ref === void 0 ? void 0 : (ref1 = ref.delivery) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.zones) === null || ref2 === void 0 ? void 0 : ref2.map(function(z) {
                return z.delivery_fee;
            })));
            return lowestFee;
        }
        return delivery.zone.delivery_fee;
    };
    _proto.distanceToRestaurant = function distanceToRestaurant() {
        var _userState = this.userState, loading = _userState.loading, addressError = _userState.addressError, user = _userState.user, delivery = _userState.delivery;
        if (loading || addressError || !user || !delivery.distanceMatrix.distance.text) {
            return "";
        }
        return delivery.distanceMatrix.distance.text;
    };
    _proto.primaryText = function primaryText() {
        return "".concat(this.deliveryTime(), " ").concat(this.deliveryType === "delivery" ? this.deliveryFee() : this.distanceToRestaurant());
    };
    _proto.secondaryText = function secondaryText() {
        return this.info.cusine.join(", ");
    };
    return HeroHelper;
}();

;// CONCATENATED MODULE: ./components/hero/HeroBottomText.tsx





var HeroBottomText = function(param) {
    var hero = param.hero;
    var ref, ref1;
    var userState = hero.userState, deliveryType = hero.deliveryType;
    if (userState.loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Hero_module_default()).bottom__container__loading
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            backgroundColor: "#f3f4f6",
            padding: "0.5rem 0"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Hero_module_default()).bottom__container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                    className: (Hero_module_default()).text,
                    primary: deliveryType === "delivery" ? "Ajunge in" : "Ridicare in",
                    secondary: hero.deliveryTime()
                }),
                deliveryType === "delivery" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            className: (Hero_module_default()).text,
                            primary: userState.addressError || !userState.user ? "Livrare de la" : "Livrare",
                            secondary: (0,helpers/* formatPrice */.T4)(hero.deliveryFee())
                        }),
                        hero.deliveryFee() === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            className: (Hero_module_default()).text,
                            primary: "Comanda min.",
                            secondary: hero.minOrder()
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            className: (Hero_module_default()).text,
                            primary: "Liv. gratis",
                            secondary: hero.freeDelivery()
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        hero.distanceToRestaurant() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            className: (Hero_module_default()).text,
                            primary: "Distanta",
                            secondary: hero.distanceToRestaurant()
                        }),
                        ((ref = hero.info.delivery) === null || ref === void 0 ? void 0 : (ref1 = ref.types) === null || ref1 === void 0 ? void 0 : ref1.includes("pickup")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            className: (Hero_module_default()).text,
                            primary: "Adresa",
                            secondary: hero.info.address.mainText.replace("Strada", "Str.").substring(0, 30)
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var hero_HeroBottomText = (HeroBottomText);

;// CONCATENATED MODULE: ./components/hero/Hero.tsx











var Hero = function(param) {
    var info = param.info;
    var ref;
    var heroBlurhash = (0,hooks/* useBlurData */.Qu)(info.images.heroBlurhash);
    var ref1 = (0,context/* useUser */.aF)(), userState = ref1.state;
    var ref2 = (0,context/* useCheckout */.Mg)(), checkoutState = ref2.state;
    var ref3 = (0,react.useState)(false), infoDialogOpen = ref3[0], setInfoDialogOpen = ref3[1];
    var toggleInfoDialog = function() {
        return setInfoDialogOpen(!infoDialogOpen);
    };
    var loading = !info || !info.openStatus;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Hero_module_default()).main__container
        });
    }
    var hero = new HeroHelper(info, userState, checkoutState.delivery.type);
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Hero_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Hero_module_default()).half__bg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Hero_module_default()).img__container,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Hero_module_default()).img__sub__container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Hero_module_default()).img__wrapper,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            "aria-label": "info",
                                            className: (Hero_module_default()).info__button,
                                            onClick: toggleInfoDialog,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoRounded, {
                                                htmlColor: "white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            className: (Hero_module_default()).img,
                                            src: (ref4 = info === null || info === void 0 ? void 0 : (ref = info.images) === null || ref === void 0 ? void 0 : ref.heroUrl) !== null && ref4 !== void 0 ? ref4 : "",
                                            alt: config/* CONFIG.RESTAURANT_NAME */.kh.RESTAURANT_NAME,
                                            layout: "fill",
                                            blurDataURL: heroBlurhash,
                                            placeholder: "blur",
                                            priority: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Hero_module_default()).img__bg
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Hero_module_default()).text__container,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Hero_module_default()).logo__container,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                className: (Hero_module_default()).logo,
                                                src: info.images.logoUrl,
                                                layout: "fixed",
                                                width: 100,
                                                height: 100,
                                                alt: "".concat(config/* CONFIG.RESTAURANT_NAME */.kh.RESTAURANT_NAME, " logo"),
                                                placeholder: "blur",
                                                blurDataURL: heroBlurhash
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                style: {
                                                    color: "white",
                                                    margin: 0
                                                },
                                                children: hero.secondaryText()
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_HeroBottomText, {
                hero: hero
            }),
            infoDialogOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(info_InfoDialog, {
                info: info,
                open: infoDialogOpen,
                onClose: toggleInfoDialog
            })
        ]
    });
};
/* harmony default export */ var hero_Hero = (Hero);

// EXTERNAL MODULE: ./components/tabLayout/TabLayout.tsx
var TabLayout = __webpack_require__(51096);
// EXTERNAL MODULE: ./components/product/menu/MenuList.tsx
var MenuList = __webpack_require__(27369);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/firebase/firestore/dist/index.esm.js + 2 modules
var index_esm = __webpack_require__(25321);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./interfaces/order.ts
var interfaces_order = __webpack_require__(54163);
// EXTERNAL MODULE: ./utils/clientFirebase.ts + 2 modules
var clientFirebase = __webpack_require__(49251);
// EXTERNAL MODULE: ./utils/orderHelpers.ts
var orderHelpers = __webpack_require__(15337);
;// CONCATENATED MODULE: ./components/order/ActiveOrderBar.tsx










var ActiveOrderBar = function() {
    var state = (0,context/* useUser */.aF)().state;
    var ref1 = (0,react.useState)(null), order = ref1[0], setOrder = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        if (!state.user) return;
        var unsubscribe = (0,index_esm/* onSnapshot */.cf)((0,index_esm/* query */.IO)((0,index_esm/* collection */.hJ)(clientFirebase/* clientDb */.Le, "restaurants/".concat(config/* CONFIG.RESTAURANT_ID */.kh.RESTAURANT_ID, "/orders")), (0,index_esm/* where */.ar)("uid", "==", (ref = state.user) === null || ref === void 0 ? void 0 : ref.uid), (0,index_esm/* where */.ar)("status", "in", interfaces_order/* activeOrderStatus */.i6), (0,index_esm/* orderBy */.Xo)("createdAt", "desc"), (0,index_esm/* limit */.b9)(1)), function(snapshot) {
            if (snapshot.empty) {
                setOrder(null);
            } else {
                var orders = snapshot.docs.map(function(doc) {
                    return doc.data();
                });
                setOrder(orders[0]);
            }
        }, function(error) {
            console.error(error.message);
        });
        return function() {
            return unsubscribe();
        };
    }, [
        state.user
    ]);
    if (state.loading || !state.user || !order) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            backgroundColor: "#FBF2D5"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            className: "pv05",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "orders/".concat(order.id),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "between",
                    style: {
                        color: "#877d51"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            children: [
                                "Comanda ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                    children: [
                                        "#",
                                        order.trackingId
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "button",
                            children: [
                                "Status:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: (0,orderHelpers/* formattedOrderStatus */._1)(order.status).toLowerCase()
                                }),
                                " "
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var order_ActiveOrderBar = (ActiveOrderBar);

// EXTERNAL MODULE: ./components/cart/HomepageCartButton.tsx
var HomepageCartButton = __webpack_require__(69131);
;// CONCATENATED MODULE: ./components/index.ts

var DeliveryTypeSelector = (0,dynamic["default"])(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 94313));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94313)
            ];
        }
    },
    ssr: false
});







// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./utils/pushNotifications.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var fetchToken = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
        var token;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,clientFirebase/* getToken */.LP)(clientFirebase/* messaging */.Fw, {
                        vapidKey: config/* CONFIG.VAPID_KEY */.kh.VAPID_KEY
                    });
                case 3:
                    token = _ctx.sent;
                    if (!token) {
                        _ctx.next = 9;
                        break;
                    }
                    console.log("current token for client: ", token);
                    return _ctx.abrupt("return", token);
                case 9:
                    console.log("No registration token available. Request permission to generate one.");
                    return _ctx.abrupt("return", null);
                case 11:
                    _ctx.next = 17;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("An error occurred while retrieving token. ", _ctx.t0);
                    throw _ctx.t0;
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function fetchToken() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./pages/index.tsx








var HomePage = function() {
    var ref2 = (0,context/* useStore */.oR)(), info = ref2.info, restaurant = ref2.restaurant;
    var alert = (0,context/* useAlert */.VY)();
    (0,react.useEffect)(function() {
        fetchToken();
        var unsub = (0,clientFirebase/* onMessage */.ps)(clientFirebase/* messaging */.Fw, function(payload) {
            var ref, ref1;
            console.log("Message received. ", payload);
            alert.show("success", (ref = payload.notification) === null || ref === void 0 ? void 0 : ref.title, (ref1 = payload.notification) === null || ref1 === void 0 ? void 0 : ref1.body);
        });
        return function() {
            return unsub();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: config/* CONFIG.RESTAURANT_NAME */.kh.RESTAURANT_NAME,
                description: (0,helpers/* getSEODesc */.d2)(info, restaurant.menus),
                url: info.url,
                imageUrl: info.images.heroUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_Hero, {
                info: info
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(order_ActiveOrderBar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryTypeSelector, {
                paddingTop: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabLayout/* default */.Z, {
                menus: restaurant.menus
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList/* default */.Z, {
                menus: restaurant.menus,
                toppings: restaurant.toppings
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageCartButton/* default */.Z, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (HomePage);


/***/ }),

/***/ 15337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gq": function() { return /* binding */ nextOrderStatus; },
/* harmony export */   "_1": function() { return /* binding */ formattedOrderStatus; },
/* harmony export */   "oV": function() { return /* binding */ nextOrderStatusText; },
/* harmony export */   "zh": function() { return /* binding */ orderStatusColor; },
/* harmony export */   "DM": function() { return /* binding */ formattedDeliveryType; },
/* harmony export */   "gk": function() { return /* binding */ formattedPaymentTypeOrder; }
/* harmony export */ });
/* unused harmony exports minOrderError, formattedPaymentType */
/* harmony import */ var _interfaces_order__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54163);

var minOrderError = function(order, deliveryZone) {
    var ref;
    return order.products.length > 0 && ((ref = order.delivery) === null || ref === void 0 ? void 0 : ref.type) === "delivery" && order.payment.subTotal < deliveryZone.min_order;
};
var nextOrderStatus = function(order) {
    switch(order.status){
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.PENDING */ .iF.PENDING:
            return _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.ACCEPTED */ .iF.ACCEPTED;
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.ACCEPTED */ .iF.ACCEPTED:
            return _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.READY */ .iF.READY;
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.READY */ .iF.READY:
            return order.delivery.type === "pickup" ? _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.DELIVERED */ .iF.DELIVERED : _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.ON_THE_WAY */ .iF.ON_THE_WAY;
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.ON_THE_WAY */ .iF.ON_THE_WAY:
            return _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.DELIVERED */ .iF.DELIVERED;
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.CANCELED */ .iF.CANCELED:
            return _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.CANCELED */ .iF.CANCELED;
        default:
            return order.status;
    }
};
var formattedOrderStatus = function(status) {
    switch(status){
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.PENDING */ .iF.PENDING:
            return "In asteptare";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.ACCEPTED */ .iF.ACCEPTED:
            return "Acceptata(e)";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.READY */ .iF.READY:
            return "Gata de livrare";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.ON_THE_WAY */ .iF.ON_THE_WAY:
            return "Pe drum";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.DELIVERED */ .iF.DELIVERED:
            return "Livrata";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.CANCELED */ .iF.CANCELED:
            return "Anulata";
    }
};
var nextOrderStatusText = function(order) {
    var type = order.delivery.type;
    switch(order.status){
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.PENDING */ .iF.PENDING:
            return "Accepta comanda";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.ACCEPTED */ .iF.ACCEPTED:
            return "Gata de livrare";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.READY */ .iF.READY:
            return type === "delivery" ? "Trimite comanda" : "Marcheaza ca ridicata";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.ON_THE_WAY */ .iF.ON_THE_WAY:
            return "Marcheaza ca livrata";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.DELIVERED */ .iF.DELIVERED:
            return type === "delivery" ? "Comanda a fost livrata" : "Comanda a fost ridicata";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.CANCELED */ .iF.CANCELED:
            return "Anulata";
    }
};
var orderStatusColor = function(status) {
    switch(status){
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.PENDING */ .iF.PENDING:
            return "#fa755a";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.ACCEPTED */ .iF.ACCEPTED:
            return "#EC8F24";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.READY */ .iF.READY:
            return "#537FC1";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.ON_THE_WAY */ .iF.ON_THE_WAY:
            return "#289D50";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.DELIVERED */ .iF.DELIVERED:
            return "#289D50";
        case _interfaces_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderStatus.CANCELED */ .iF.CANCELED:
            return "#fa755a";
        default:
            return "#000";
    }
};
var formattedDeliveryType = function(deliveryType) {
    switch(deliveryType){
        case "delivery":
            return "Livrare";
        case "pickup":
            return "Ridicare";
        default:
            return "-";
    }
};
var formattedPaymentType = function(paymentType) {
    switch(paymentType){
        case "cash":
            return "Cash";
        case "card_on_delivery":
            return "Cu cardul, la livrare";
        case "new_card":
            return "Card nou";
        case "saved_card":
            return "Card salvat";
        default:
            return null;
    }
};
var formattedPaymentTypeOrder = function(paymentType) {
    switch(paymentType){
        case "cash":
            return "Cash, la livrare";
        case "card_on_delivery":
            return "Cu cardul, la livrare";
        case "new_card":
        case "saved_card":
            return "Online, cu cardul";
        default:
            return "unknown";
    }
};


/***/ }),

/***/ 6235:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__AYvxZ","half__bg":"Hero_half__bg__VhC2v","img__container":"Hero_img__container__sSDrT","img__sub__container":"Hero_img__sub__container__pFymw","img__wrapper":"Hero_img__wrapper__42nN_","img":"Hero_img__vcN88","img__bg":"Hero_img__bg__PVs_g","text__container":"Hero_text__container__qqymU","h1":"Hero_h1__KmUkj","logo__container":"Hero_logo__container__WQDr4","logo":"Hero_logo__0l37q","bottom__container":"Hero_bottom__container__3onyu","bottom__container__loading":"Hero_bottom__container__loading__b6erV","text":"Hero_text__a3XTs","info__button":"Hero_info__button__09NcB"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [766,774,888,179], function() { return __webpack_exec__(45301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);